import { LicenseInfo } from '@mui/x-license';

const MUI_PUBLIC_LICENSE_KEY =
  'c7521b4ba5cacc087ff5247b93b71a68Tz0xMjY4NTksRT0xODA0ODk1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=';

/**
 * Registers the shared MUI X license key. Call once during app bootstrap,
 * before rendering any MUI X Pro component.
 */
export function setMuiLicenseKey(): void {
  LicenseInfo.setLicenseKey(MUI_PUBLIC_LICENSE_KEY);
}
